// Hooks / Node modules / Styles
import React, { useState } from "react";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons

function ServiceCard({ title, icon }) {
  return (
    <div className="local-theme-bg-md local-theme-border-md sm:w-[180px]  p-3 rounded-lg shadow-md flex flex-col items-center select-none">
      <div className="text-2xl flex justify-center items-center mb-2">
        {icon}
      </div>
      <h3 className="local-theme-text-md text-[16px] font-semibold text-center">
        {title}
      </h3>
    </div>
  );
}

export default ServiceCard;
